import {connect} from 'react-redux';
import {ModalStates} from '../../globals/Constants';
import Action from '../../redux/Actions';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';
import ModalManager, {ModalManagerProps} from './ModalManager';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import {RouteComponentProps, withRouter} from 'react-router';

const mapStateToProps = (state: ReduxState, ownProps: RouteComponentProps): Partial<ModalManagerProps> => {
   return {
      ...ownProps,
      themeName: state.themeName,
      modalState: state.modalState || ModalStates.closed,
      reviewerGroups: state.reviewerGroups || [],
      review: state.currentReview,
      isOwner: state.isOwner,
      versionNumber: state.currentReviewVersion ? state.currentReviewVersion.VersionNumber : 1
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ModalManagerProps> => {
   return {
      setModalState: (modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel) => {
         dispatch(Action.setModalState({modalState}, modalEventHandlersModel));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalManager));
